import request from '@/router/axios'
import env from '@/config/env'
// ==================代理商管理=======================

// 代理商分页
export const agentList = (params) => {
  return request({
    url: env.ferryUrl + '/agent/v2/page',
    method: 'POST',
    data: params
  })
}
// 获取角色列表
export const agentTypeList = (params) => {
  return request({
    url: env.ferryUrl + '/agent-role/v2/list',
    method: 'GET',
    params
  })
}
// 代理商账号封禁-解禁
export const ban = (params) => {
  return request({
    url: env.ferryUrl + '/agent/v2/ban',
    method: 'POST',
    data: params
  })
}
// 代理商详情
export const detail = (id) => {
  return request({
    url: env.ferryUrl + '/agent/v2/detail/' + id,
    method: 'GET'
  })
}
// 代理商批量修改角色
export const batchEdit = (params) => {
  return request({
    url: env.ferryUrl + '/agent/v2/batch-edit-role',
    method: 'POST',
    data: params
  })
}

// ==================提现记录=======================

// 云推官提现记录分页
export const withdrawalList = (params) => {
  return request({
    url: env.ferryUrl + '/agent-v2-withdrawal/page',
    method: 'POST',
    data: params
  })
}
// 打款配置详情
export const payConfig = (params) => {
  return request({
    url: env.ferryUrl + '/agent-v2-withdrawal/payConfig',
    method: 'GET',
    params
  })
}
// 打款配置日志
export const payConfigLog = (params) => {
  return request({
    url: env.ferryUrl + '/agent-v2-withdrawal/payConfigLog',
    method: 'GET',
    params
  })
}
// 根据支付渠道获取商户实体列表
export const paymentEntity = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listPayMerchantByPayChannelId',
    method: 'GET',
    params
  })
}
// 根据商户实体获取商户号列表
export const paymentMerchantNo = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listPayMerchantByMerchantEntityName',
    method: 'GET',
    params
  })
}
// 打款配置编辑
export const payConfigSave = (params) => {
  return request({
    url: env.ferryUrl + '/agent-v2-withdrawal/payConfig',
    method: 'PUT',
    data: params
  })
}
// 打款配置编辑
export const payAgain = (params) => {
  return request({
    url: env.ferryUrl + '/agent-v2-withdrawal/payAgain',
    method: 'POST',
    data: params
  })
}
// 云推官提现记录导出
export const exportRecord = (params) => {
  return request({
    url: env.ferryUrl + '/agent-v2-withdrawal/exportRecord',
    method: 'GET',
    params
  })
}

// ==================云推官规则=======================

// 规则
export const ruleDetail = () => {
  return request({
    url: env.ferryUrl + '/agent-commission-rule/v2/rule',
    method: 'GET'
  })
}
// 通用规则新增
export const commonSave = (params) => {
  return request({
    url: env.ferryUrl + '/agent-commission-rule/v2/common-save',
    method: 'POST',
    data: params
  })
}
// 区域规则新增
export const areaSave = (params) => {
  return request({
    url: env.ferryUrl + '/agent-commission-rule/v2/area-save',
    method: 'POST',
    data: params
  })
}
// 区域规则删除
export const areaDelete = (id) => {
  return request({
    url: env.ferryUrl + '/agent-commission-rule/v2/area-delete/' + id,
    method: 'DELETE'
  })
}
// 提现时间修改
export const commissionTime = (params) => {
  return request({
    url: env.ferryUrl + '/agent-commission-rule/v2/commission-time',
    method: 'POST',
    data: params
  })
}
// 根据云推官类型获取规则
export const commonRuleByRole = (params) => {
  return request({
    url: env.ferryUrl + '/agent-commission-rule/v2/common-rule-by-role',
    method: 'GET',
    params
  })
}
// 通用规则删除
export const commonDelete = (id) => {
  return request({
    url: env.ferryUrl + '/agent-commission-rule/v2/common-delete/' + id,
    method: 'DELETE'
  })
}

// ==================云推官提成=======================

// 根据云推官类型获取规则
export const commissionPage = (params) => {
  return request({
    url: env.ferryUrl + '/agent-commission/v2/page',
    method: 'POST',
    data: params
  })
}
// 获取银行卡信息
export const getCardInfo = (agentId) => {
  return request({
    url: env.ferryUrl + `/agent/v2/bankCardInfo/${agentId}`,
    method: 'GET'
  })
}
// 更新银行卡信息
export const setCardInfo = (agentId, data) => {
  return request({
    url: env.ferryUrl + `/agent/v2/bankCardInfo/${agentId}`,
    method: 'PUT',
    data
  })
}
// 银行卡打款
export const doPay = (data) => {
  return request({
    url: env.ferryUrl + '/agent-v2-withdrawal/pay',
    method: 'POST',
    data
  })
}
// 获取打款类型
export const getTypeList = (agentId) => {
  return request({
    url: env.ferryUrl + '/agent-v2-withdrawal/payTypeList',
    method: 'GET'
  })
}
// 获取身份证号
export const getIdNum = (agentId) => {
  return request({
    url: env.ferryUrl + '/agent/v2/bankCardIdNum/' + agentId,
    method: 'GET'
  })
}
